var __jsx = React.createElement;
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import React from "react";
import AwesomeIcon from "../AwesomeIcon";
import { getFormattedDate } from "../../utils";
export default function PatientList(_ref) {
  var patients = _ref.patients,
    onChange = _ref.onChange,
    patientsCount = _ref.patientsCount,
    isClearFilter = _ref.isClearFilter,
    displayMessage = _ref.displayMessage;
  if (displayMessage) {
    return /*#__PURE__*/React.createElement("div", {
      className: "px-5 py-4 rounded-lg max-w-[75%] dark:bg-gray-800 bg-gray-500 text-white rounded-tl-none"
    }, /*#__PURE__*/React.createElement("p", {
      className: "whitespace-pre-wrap"
    }, displayMessage));
  }
  if (isClearFilter) {
    return /*#__PURE__*/React.createElement("div", {
      className: "px-5 py-4 rounded-lg max-w-[75%] dark:bg-gray-800 bg-gray-500 text-white rounded-tl-none"
    }, /*#__PURE__*/React.createElement("p", {
      className: "whitespace-pre-wrap"
    }, "All filters have been cleared."));
  }
  if (!patients || patients.length === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "px-5 py-4 rounded-lg max-w-[75%] dark:bg-gray-800 bg-gray-500 text-white rounded-tl-none"
    }, /*#__PURE__*/React.createElement("p", {
      className: "whitespace-pre-wrap"
    }, "No patients found, please try again."));
  }
  // Function to map gender number to string
  var getGenderString = function getGenderString(genderCode) {
    switch (genderCode) {
      case 0:
        return "M";
      case 1:
        return "F";
      case 2:
        return "O";
      // Based on the data, assuming 3 is Female
      default:
        return "";
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "dark:text-gray-200"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-[80%] border dark:border-gray-800 border-gray-300 rounded-md rounded-tl-none shadow-md dark:bg-gray-800 bg-gray-500"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center space-x-1 mb-3 p-4 dark:bg-gray-800 bg-gray-500 rounded-t-md"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-lg font-bold text-white"
  }, "Filtered Patients"), /*#__PURE__*/React.createElement("div", {
    className: "text-[#FFA387] text-md"
  }, patients.length, " of ", patientsCount, " patients")), /*#__PURE__*/React.createElement("div", {
    className: "dark:bg-gray-900 bg-gray-200 rounded-md overflow-hidden shadow-md"
  }, patients.map(function (patient, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: patient === null || patient === void 0 ? void 0 : patient.patient_uid,
      className: "flex flex-col p-4 dark:hover:bg-gray-800/50 hover:bg-gray-300/50 transition-colors ".concat(index < patients.length - 1 ? "border-b dark:border-gray-800 border-gray-300" : ""),
      onClick: function onClick() {
        onChange(patient.patient_uid);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-3"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
      className: "text-base font-medium dark:text-white text-gray-600 capitalize"
    }, (patient === null || patient === void 0 ? void 0 : patient.name.length) > 20 ? (patient === null || patient === void 0 ? void 0 : patient.name.slice(0, 20)) + "... " : patient === null || patient === void 0 ? void 0 : patient.name), /*#__PURE__*/React.createElement("div", {
      className: "flex text-sm dark:text-gray-400 text-gray-500 space-x-3"
    }, /*#__PURE__*/React.createElement("span", null, patient === null || patient === void 0 ? void 0 : patient.age, "Y ", getGenderString(patient === null || patient === void 0 ? void 0 : patient.gender)), /*#__PURE__*/React.createElement("span", {
      className: "",
      title: patient === null || patient === void 0 ? void 0 : patient.patient_id
    }, patient === null || patient === void 0 ? void 0 : patient.patient_id)))), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center space-x-4"
    }, /*#__PURE__*/React.createElement("button", {
      className: "h-6 w-6 rounded-md dark:bg-gray-800 bg-gray-100 flex items-center justify-center hover:bg-[#FFA387]/20 transition-colors"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faChevronRight,
      className: "h-4 w-4 text-[#FFA387]"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end text-xs text-gray-500 mt-2"
    }, (patient === null || patient === void 0 ? void 0 : patient.workspace_display_name) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, patient === null || patient === void 0 ? void 0 : patient.workspace_display_name), /*#__PURE__*/React.createElement("span", {
      className: "mx-2"
    }, "|")), /*#__PURE__*/React.createElement("span", null, getFormattedDate(patient === null || patient === void 0 ? void 0 : patient.created_at))));
  }))));
}